




















































import { JournalEntry } from "../../models/JournalEntry";
import AttachmentsDropdown from "../partials/AttachmentsDropdown.vue";

export default {
    name: "JournalEntryModalDisplay",
    components: { AttachmentsDropdown },
    props: {
        entry: JournalEntry,
    },
    computed: {
        showAttachments: function () {
            return (
                this.entry.files.length > 0 ||
                this.entry.mail_attachments.length > 0
            );
        },
    },
};
